export default __webpack_public_path__ + "static/media/web.79202521.png";